import { useState } from 'react';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { CalendarTab } from './CalendarTab';
import { ClassesTab } from './ClassesTab';
import { HousesTab } from './HousesTab';
import { SubjectsTab } from './SubjectsTab';
import { TeachingTab } from './TeachingTab';
import { TermsTab } from './TermsTab';

const TABS = ['classes', 'subjects', 'terms', 'houses', 'teaching', 'calendar'] as const;
type Tab = (typeof TABS)[number];

export function AcademicsPage() {
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('classes');

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('acad.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && (
        <>
          <div
            role="tablist"
            aria-label={t('acad.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {TABS.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={tab === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${tab === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`acad.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {tab === 'classes' && <ClassesTab schoolId={schoolId} />}
            {tab === 'subjects' && <SubjectsTab schoolId={schoolId} />}
            {tab === 'terms' && <TermsTab schoolId={schoolId} />}
            {tab === 'houses' && <HousesTab schoolId={schoolId} />}
            {tab === 'teaching' && <TeachingTab schoolId={schoolId} />}
            {tab === 'calendar' && <CalendarTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
